import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './globals1.css';
import NiceModal from '@ebay/nice-modal-react';
import './services/signalr.service';
import { SignalRService } from './services/signalr.service';

SignalRService.getInstance();


createRoot(document.getElementById('root')!).render(
	<StrictMode>

		<App />

	</StrictMode>,
)
